import { ResultSet } from "@cubejs-client/core";

import { AppThunk } from "appThunk";
import { DateTime } from "luxon";
import { cubeLoad } from "modules/helpers/cube/cubeSlice";
import { logError } from "modules/helpers/logger/loggerSlice";
export class FootfallOverTime {
    public readonly retailCentreId: number;
    public readonly date: DateTime;
    public readonly numberOfVisits: number;
    public readonly dwellTime: number;

    constructor(
        retailCentreId: number,
        date: DateTime,
        numberOfVisits: number,
        dwellTime: number,
    ) {
        this.retailCentreId = retailCentreId;
        this.date = date;
        this.numberOfVisits = numberOfVisits;
        this.dwellTime = dwellTime;
    }
}

export const loadFootfallOverTime = (retailCentreIds: number[]): AppThunk<Promise<FootfallOverTime[]>> => async (dispatch) => {
    try {
        const retailCentreStrings = retailCentreIds.map(id => id.toString());
        if (retailCentreStrings.length === 0) {
            return [];
        }
        const query = {
            dimensions: [
                "Footfall_RC_Monthly.RetailCentreID",
                "Footfall_RC_Monthly.MonthDate",
                "Footfall_RC_Monthly.FootfallCount",
                "Footfall_RC_Monthly.DwellTime"
            ],
            filters: [{
                member: "Footfall_RC_Monthly.RetailCentreID",
                operator: "equals",
                values: retailCentreStrings
            }]
        };
        const resultSet = await dispatch(cubeLoad(query)) as unknown as ResultSet;
        return resultSet.rawData().map(row => {
            return new FootfallOverTime(
                Number(row["Footfall_RC_Monthly.RetailCentreID"]),
                DateTime.fromISO(row["Footfall_RC_Monthly.MonthDate"], { zone: "utc" }),
                Number(row["Footfall_RC_Monthly.FootfallCount"]),
                Number(row["Footfall_RC_Monthly.DwellTime"])
            );
        });
    } catch (error) {
        dispatch(logError("Error loading FootfallOverTime.", error));
        throw error;
    }
};
